/* eslint-disable react/prop-types */
import algoliasearch from 'algoliasearch/lite';
import PropTypes from 'prop-types';
import React from 'react';
import { FaSearch } from 'react-icons/fa';
import { Configure, Hits, InstantSearch, SearchBox } from 'react-instantsearch';

import * as S from './SearchEngine.styles';

export const SearchEngine = ({ autoFocus, placeholder, lang, isEvent }) => {
  if (!autoFocus || !placeholder || !lang) {
    return null;
  }

  const searchClient = algoliasearch(
    process.env.GATSBY_ALGOLIA_APP_ID,
    process.env.GATSBY_ALGOLIA_SEARCH_KEY
  );

  const Hit = ({ hit }) => {
    const { title, description, url } = hit || '';

    if (!title || !description || !url) {
      return null;
    }

    return (
      <S.HitContainer href={url}>
        <S.PageTitle>
          <S.Title>{title}</S.Title>
        </S.PageTitle>
        <S.PageDescription>
          <S.Description>{description}</S.Description>
        </S.PageDescription>
      </S.HitContainer>
    );
  };

  const indexName = isEvent
    ? `Event-Index-${lang.slice(0, 2)}`
    : `Index-${lang.slice(0, 2)}`;

  return (
    <S.InstantSearchWrapper>
      <InstantSearch indexName={indexName} searchClient={searchClient}>
        <Configure hitsPerPage={5} />
        <S.AlgoliaSearchHeader>
          <FaSearch id='fasearch' />
          <S.StyledSearchBox>
            <SearchBox
              autoFocus={autoFocus}
              translations={{ placeholder }}
              placeholder={placeholder}
            />
          </S.StyledSearchBox>
        </S.AlgoliaSearchHeader>
        <S.AlgoliaSearchMain>
          <S.CustomHistsContainer>
            <Hits hitComponent={Hit} />
          </S.CustomHistsContainer>
        </S.AlgoliaSearchMain>
      </InstantSearch>
    </S.InstantSearchWrapper>
  );
};

SearchEngine.propTypes = {
  autoFocus: PropTypes.bool,
  lang: PropTypes.string,
  placeholder: PropTypes.string,
};
